import { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { useGetAssetTypesQuery } from '@/store/services'
import Select from 'react-select'
import { SelectWrapper } from '../wrapper'

export const AssetTypeSelector = ({ categoryId, value, onChange, includeAll = true, className = '' }) => {
  const { data: { asset_types: types = [] } = {}, isLoading } = useGetAssetTypesQuery(categoryId, { skip: !categoryId })
  const [selected, setSelected] = useState(null)

  const options = useMemo(() => ([
    ...(includeAll ? [{ value: null, label: 'Todos' }] : []),
    ...types.map((t) => ({ value: t.id, label: t.name }))
  ]), [types, includeAll])

  useEffect(() => {
    const next = options.find((opt) => opt.value === value) || (includeAll ? options[0] : null)
    setSelected(next)
  }, [value, options, includeAll, categoryId])

  const handleChange = (opt) => {
    setSelected(opt)
    onChange?.(opt ? opt.value : null)
  }

  return (
    <div className={className}>
      <SelectWrapper label='Tipo'>
        {(styles) => (
          <Select
            isClearable={!includeAll}
            isSearchable
            isLoading={isLoading}
            options={options}
            value={selected}
            placeholder={categoryId ? 'Selecciona' : 'Primero elige categoría'}
            onChange={handleChange}
            styles={styles}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            isDisabled={!categoryId || isLoading}
          />
        )}
      </SelectWrapper>
    </div>
  )
}
